export const getHeadrestException = (state) => {
    if (state.backrest !== "postural") {
        return "Not available with waterfall backrest.";
    }
    return null;
};
